import { render, staticRenderFns } from "./AppBarClientMenuItem.vue?vue&type=template&id=65931694&scoped=true"
import script from "./AppBarClientMenuItem.vue?vue&type=script&lang=js"
export * from "./AppBarClientMenuItem.vue?vue&type=script&lang=js"
import style0 from "./AppBarClientMenuItem.vue?vue&type=style&index=0&id=65931694&prod&scoped=true&lang=css"
import style1 from "./AppBarClientMenuItem.vue?vue&type=style&index=1&id=65931694&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65931694",
  null
  
)

export default component.exports